
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";

interface VisaType {
  id: string;
  name_ar: string;
  name_en: string;
  created_at: string;
  updated_at: string;
}

interface VisaTypeCardProps {
  visaType: VisaType;
  onEdit: () => void;
  onDelete: () => void;
}

export const VisaTypeCard = ({ visaType, onEdit, onDelete }: VisaTypeCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{visaType.name_ar}</CardTitle>
        <CardDescription>{visaType.name_en}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex gap-2 justify-end">
          <Button
            variant="ghost"
            size="sm"
            onClick={onEdit}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDelete}
            className="text-red-600 hover:text-red-700"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
